(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-modal"]) return;
  try {
    
								document.addEventListener('DOMContentLoaded', function() {

									const params = new URLSearchParams(window.location.search);

									if (params.get('contact_posted') === 'true') {

										const modalElement = document.getElementById('contact');

										if (modalElement) {
											const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
											modal.show();
										}

									}

								});
							
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshops"] && !Shopify.designMode) return;
  try {
    
const list = document.querySelector('.workshops .list');

if (list) {
	const items = [...list.querySelectorAll('.item')];

	items
		.sort((a, b) => {
			return Number(a.dataset.date) - Number(b.dataset.date);
		})
		.forEach(item => list.appendChild(item));
}

  } catch(e) { console.error(e); }
})();
})();
